import Header from "../../components/header/Header";

function Home() {
  return <Header />;
}

export default Home;
